import Title from "../main/Title"
import CommentBox from "./CommentBox"
import { ABOUT_PAGE } from "../../data/texts"

const CommentsSection = () => {

    const data = ABOUT_PAGE
    
    return(

        <section className="flex flex-col lg:flex-row gap-6 lg:gap-16 lg:my-8">
            <div className="lg:w-2/3 ">
            <h3 className=" text-[20px] font-semibold text-[#383838]
             border-b border-b-[#D2D2D2] pb-4 mb-4">
                   <span>
                    کاربران درباره‌ی مدیزن چه
                   </span>
                   <Title text={' نظری '}/>
                   <span>
                    دارند؟
                   </span>
               </h3>
            <p className="text-justify text-[15px] text-[#505050] leading-[28px]">
                {data.userReviews}
            </p>
            </div>
            <div className="lg:w-1/3 justify-end items-end">
            <CommentBox/>
            </div>
        </section>
    )
}
export default CommentsSection